'use client'

import { Button } from '@mui/material'

import useVerticalNav from '@menu/hooks/useVerticalNav'

const NavToggle = () => {
  const { toggleVerticalNav } = useVerticalNav()
  const verticalNavOptions = useVerticalNav()

  const { isCollapsed } = verticalNavOptions

  const handleClick = () => {
    toggleVerticalNav()
  }

  return (
    <>
      <Button
        variant={isCollapsed ? 'contained' : 'outlined'}
        color='primary'
        sx={{
          borderRadius: '50%',
          minWidth: '40px',
          padding: '8px',
          position: 'relative',
          overflow: 'hidden'
        }}
        onClick={handleClick}
      >
        <i
          className={`ri-${isCollapsed ? 'menu-line' : 'menu-line'} text-xl`}
          style={{
            display: 'block',
            margin: '0 auto',
            transition: 'transform 0.3s ease',
            transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        />
      </Button>
      {/* <i className='ri-menu-line text-xl cursor-pointer' onClick={handleClick} /> */}
      {/* Comment following code and uncomment above code in order to toggle menu on desktop screens as well */}
      {/* {isBreakpointReached && <i className='ri-menu-line text-xl cursor-pointer' onClick={handleClick} />} */}
    </>
  )
}

export default NavToggle
